import React from 'react'
import { connect } from 'react-redux'
import { applyIdeaMeService } from 'services/ideas'
import Navigation from 'support/navigation'
import { showPopupDialog } from 'support/popup_dialogs'
import AnalyticsService from 'support/analytics'
import NewPrivateIdea from 'components/nxt_modal_new_private_idea'
import View from './View'

const mapStateToProps = (state) => {
  return {
    userIdeas: state.data.idea.userIdeas,
    ideaStatusStepper: state.data.domain.domainConfiguration.ideaStatusStepper,
    isPrivateFlowActive: state.data.domain.domainConfiguration.isPrivateFlowActive,
    isMyIdeasLoading: state.data.idea.isMyIdeasLoading,
    customTitlesConf: state.data.domain.customTitlesConf
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getMyIdeas: () => {
      dispatch(applyIdeaMeService())
    },
    navigateToIdea: id => {
      dispatch(Navigation.navigateToIdea(id))
    },
    navigateToUserProfile: email => {
      dispatch(Navigation.navigateToUserProfile(email))
    },
    navigateToNewIdea: (isPrivate = false) => {
      AnalyticsService.trackEvent({ category: 'create-idea', action: 'click', label: 'myideas' })
      if (isPrivate) {
        showPopupDialog(<NewPrivateIdea />, dispatch)
      } else {
        dispatch(Navigation.navigateToNewIdea())
      }
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)
